import BaseProductItemModel from '../lineItemCtnr/ProductItemModel';

/**
 * Represents ProductItemModel
 */
class ProductItemModel extends BaseProductItemModel {}

export default ProductItemModel;